import { SvgIcon } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';

const PaymentStatusSAVFree = (props) => {
  const _themeColor = useSelector((state) => state?.header?.themeColor);
  return (
    <SvgIcon {...props}>
      <svg
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>Gratuit - SAV</title>
        <path
          d="M4.77 7.53001V8.66001H2.41V9.88001H4.18V10.98H2.41V13.33H1V7.53001H4.78H4.77Z"
          fill="#4EAE36"
        />
        <path
          d="M8.47001 13.33L7.26001 11.14H6.92001V13.33H5.51001V7.53001H7.88001C8.34001 7.53001 8.73001 7.61001 9.05001 7.77001C9.37001 7.93001 9.61001 8.15001 9.77001 8.43001C9.93001 8.71001 10.01 9.02001 10.01 9.36001C10.01 9.75001 9.90001 10.09 9.68001 10.39C9.46001 10.69 9.14001 10.91 8.72001 11.03L10.06 13.33H8.46001H8.47001ZM6.92001 10.14H7.80001C8.06001 10.14 8.25001 10.08 8.38001 9.95001C8.51001 9.82001 8.57001 9.64001 8.57001 9.41001C8.57001 9.18001 8.51001 9.02001 8.38001 8.89001C8.25001 8.76001 8.06001 8.70001 7.80001 8.70001H6.92001V10.14Z"
          fill="#4EAE36"
        />
        <path
          d="M12.31 8.66V9.83H14.2V10.92H12.31V12.19H14.45V13.32H10.9V7.52H14.45V8.65H12.31V8.66Z"
          fill="#4EAE36"
        />
        <path
          d="M16.79 8.66V9.83H18.68V10.92H16.79V12.19H18.93V13.32H15.38V7.52H18.93V8.65H16.79V8.66Z"
          fill="#4EAE36"
        />
      </svg>
    </SvgIcon>
  );
};

export default PaymentStatusSAVFree;
